import { render, staticRenderFns } from "./TestPage.vue?vue&type=template&id=5bf6ee53&scoped=true&"
import script from "./TestPage.vue?vue&type=script&lang=js&"
export * from "./TestPage.vue?vue&type=script&lang=js&"
import style0 from "./TestPage.vue?vue&type=style&index=0&id=5bf6ee53&scoped=true&lang=scss&"
import style1 from "./TestPage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf6ee53",
  null
  
)

export default component.exports